// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__Wjvp3","spinner":"Spinner_spinner__RNdMU","spin":"Spinner_spin__wGNK5"};